<template>
    <a-card>

      <vs-tabs alignment="center" v-model="tabs">
        <vs-tab label="بایگانی پرسنل">
          <x-table v-if="$getAccess('archive.personnel.show')" v-show="tabs == 0" :model="personnelCols" ref="personnelTbl" class="mt-3">
            <div slot="operator" slot-scope="text,record" class="grid grid-cols-1 md:grid-cols-1 gap-2">
<!--              v-if="$getAccess('personnel.delete')"-->
              <a-popconfirm title="آیا می خواهید بازیابی کنید؟" v-if="$getAccess('archive.personnel.restore')"
                  ok-text="بله"
                  cancel-text="خیر"
                  @confirm="restorePersonnel(text.record.id)"
              >
                <a-button type="primary">بازیابی اطلاعات</a-button>
              </a-popconfirm>
<!--              <a-popconfirm title="آیا می خواهید حذف کنید؟" v-if="$getAccess('archive.personnel.destroy')"
                  ok-text="بله"
                  cancel-text="خیر"
                  @confirm="deletePersonnel(text.record.id)"
              >
                <a-button type="danger">حذف اطلاعات</a-button>
              </a-popconfirm>-->
            </div>
          </x-table>
        </vs-tab>
        <vs-tab label="بایگانی درخواست ها">
          <x-table v-if="$getAccess('archive.proposal.show')" v-show="tabs == 1" :model="proposalCols" ref="proposalTbl" class="mt-3">
            <div slot="operator" slot-scope="text,record" class="grid grid-cols-1 md:grid-cols-1 gap-2">
              <a-popconfirm title="آیا می خواهید بازیابی کنید؟" v-if="$getAccess('archive.proposal.restore')"
                  ok-text="بله"
                  cancel-text="خیر"
                  @confirm="restoreProposal(text.record.id)"
              >
                <a-button type="primary">بازیابی اطلاعات</a-button>
              </a-popconfirm>
<!--              <a-popconfirm title="آیا می خواهید حذف کنید؟" v-if="$getAccess('archive.proposal.destroy')"
                  ok-text="بله"
                  cancel-text="خیر"
                  @confirm="deleteProposal(text.record.id)"
              >
                <a-button type="danger">حذف اطلاعات</a-button>
              </a-popconfirm>-->
            </div>
          </x-table>
        </vs-tab>
      </vs-tabs>
    </a-card>
</template>

<script>
import personnelCols from './personelTbl';
import proposalCols from './proposalTbl';
import XTable from "@/components/new-x-table/XTable";
import axios from "@/axios"

export default {
  components: {
    XTable
  },
  data() {
    return {
/*      prsonalFileList: [],
      file_id: undefined,
      showMosahebeModal: false,
      showInformationModal: false,
      showAddMosahebeModal: false,
      personalInformation: {},
      personalDetails: {},*/
      personnelCols,
      proposalCols,
      tabs: 0,
     /* current: 0,
      fromMosahebe: this.$form.createForm(this, {name: 'coordinated'}),
      mosahebe: null,
      interview_at: null,
      row_id: null,
      interview: [],
      title_interview: ['دانش تخصصی', 'تحصیلات مرتبط', 'تجربه کاری مرتبط', 'رفتار و شخصیت عمومی', 'ویژگی های اختصاصی شغل'],
      is_skeleton: false,

      // requestEditMode:false,
      editInterviewModel: false,
      editingInterviewIndex: undefined,
      mosahebeData: {},
      fromMosahebe0: this.$form.createForm(this, {name: 'coordinated'}),
      fromMosahebe1: this.$form.createForm(this, {name: 'coordinated'}),
      fromMosahebe2: this.$form.createForm(this, {name: 'coordinated'}),
      fromPersonel: this.$form.createForm(this, {name: 'coordinated'}),
      setEmployeModel: false,
      loading: false,
      userTypes: [],*/
    }
  },
/*  computed: {
    admin(){
      return JSON.parse(localStorage.userInfo).name
    }
  },*/
  methods: {
    async restorePersonnel(id) {
      try {
        this.is_skeleton = true
        await axios.get(`personnel/restore/${id}`)
        this.$refs.personnelTbl.fetch()
        this.$ntSet()
      } catch (e) {
        this.$ntSetError()
      } finally {
        this.is_skeleton = false
      }
    },

    async deletePersonnel(id) {
      try {
        this.is_skeleton = true
        await axios.delete(`personnel/delete/${id}`)
        this.$refs.personnelTbl.fetch()
        this.$ntSet()
      } catch (e) {
        this.$ntSetError()
      } finally {
        this.is_skeleton = false
      }
    },
    async restoreProposal(id) {
      try {
        this.is_skeleton = true
        await axios.get(`proposal/restore/${id}`)
        this.$refs.proposalTbl.fetch()
        this.$ntSet()
      } catch (e) {
        this.$ntSetError()
      } finally {
        this.is_skeleton = false
      }
    },
    async deleteProposal(id) {
      try {
        this.is_skeleton = true
        await axios.delete(`proposal/${id}`)
        this.$refs.proposalTbl.fetch()
        this.$ntSet()
      } catch (e) {
        this.$ntSetError()
      } finally {
        this.is_skeleton = false
      }
    },

  },
  async created() {
    // await this.getUserTypes()
  }
}
</script>

<style scoped>

</style>